module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Home"},"fr":{"title":"Habitation"}}')
  delete Component.options._Ctor
}
